<div class="titre-view-container p-4">
  <!-- Informations de l'émission -->
  <div class="emission-details mb-4" *ngIf="emission">
    <h3 class="text-gray-600 mb-3">INFORMATIONS DE L'ÉMISSION</h3>
    <div class="detail-row">
      <span class="detail-label">Émetteur:</span>
      <span class="detail-value">
        <div class="flex align-items-center gap-2">
          <img *ngIf="emission.region"
               [src]="'https://purecatamphetamine.github.io/country-flag-icons/3x2/' + emission.region.toUpperCase() + '.svg'"
               style="width: 24px; height: 18px;"
               [alt]="getCountryName(emission.region)" />
          <span>{{ getCountryName(emission.region) }}</span>
        </div>
      </span>
    </div>
    <div class="detail-row">
      <span class="detail-label">Date de l'opération:</span>
      <span class="detail-value">{{ formatDate(emission.operationDate) }}</span>
    </div>
    <div class="detail-row">
      <span class="detail-label">Montant mis en adjudication:</span>
      <span class="detail-value">{{ formatCurrency(emission.amount) }} millions de FCFA</span>
    </div>
    <div class="detail-row">
      <span class="detail-label">Date de valeur:</span>
      <span class="detail-value">{{ formatDate(emission.valueDate) }}</span>
    </div>
  </div>

  <!-- Détails du titre -->
  <div *ngIf="titre">
    <h3 class="text-primary mb-3">{{ titre.typeInstrument }}</h3>

    <div class="emission-details">
      <div class="detail-row" *ngIf="titre.isin">
        <span class="detail-label">Code ISIN:</span>
        <span class="detail-value">{{ titre.isin }}</span>
      </div>
      <div class="detail-row">
        <span class="detail-label">Durée:</span>
        <span class="detail-value">{{ titre.duration }} mois</span>
      </div>
      <div class="detail-row">
        <span class="detail-label">Différé:</span>
        <span class="detail-value">-- an(s)</span>
      </div>
      <div class="detail-row">
        <span class="detail-label">Échéance:</span>
        <span class="detail-value">{{ formatDate(titre.dueDate) }}</span>
      </div>
      <div class="detail-row">
        <span class="detail-label">Taux d'intérêt:</span>
        <span class="detail-value">{{ titre.rate ? (titre.rate + ' %') : '%' }}</span>
      </div>
      <div class="detail-row">
        <span class="detail-label">Valeur nominale unitaire:</span>
        <span class="detail-value">{{ formatCurrency(titre.unitNominalValue) }} F CFA</span>
      </div>
      <div class="detail-row">
        <span class="detail-label">Remboursement:</span>
        <span class="detail-value">
          <span *ngIf="titre.typeInstrument === 'BAT'">
            Les titres émis sont remboursables le premier jour ouvré suivant la date d'échéance.<br>
            Les intérêts sont payables d'avance et précomptés sur la valeur nominale des bons
          </span>
          <span *ngIf="titre.typeInstrument === 'OAT'">
            Le remboursement de ces obligations se fera le premier jour ouvrable suivant la date d'échéance (remboursement In Fine).
            Le paiement des intérêts se fera à un taux d'intérêt de {{ titre.rate }}% l'an dès la première année.
          </span>
        </span>
      </div>
    </div>
  </div>

  <!-- Bouton de fermeture -->
  <div class="flex justify-content-end mt-4">
    <p-button
      label="Fermer"
      icon="pi pi-times"
      (onClick)="close()"
      severity="danger">
    </p-button>
  </div>
</div>
